import { useAuth } from "@contexts/Auth";
import { ownerApi } from "@root/endpoints/TimeTactApi/ownerApi";
import { studentApi } from "@root/endpoints/TimeTactApi/studentApi";
import { superOwnerApi } from "@root/endpoints/TimeTactApi/superOwnerApi";
import { teacherApi } from "@root/endpoints/TimeTactApi/teacherApi";

type Props = {
  handleChange: (value: string, shouldSave?: boolean) => void;
};

export const useTagInputService = ({ handleChange }: Props) => {
  const {
    isCurrentRoles: { isTeacher, isOwner, isStudent },
  } = useAuth();
  const handleGetCommonTagQuery = () => {
    if (isTeacher) return teacherApi.endpoints.getCommonTagsAsTeacher;
    if (isOwner) return ownerApi.endpoints.getCommonTagsAsOwner;
    if (isStudent) return studentApi.endpoints.getCommonTagsAsStudent;
    return superOwnerApi.endpoints.getCommonTagsAsSuperOwner;
  };

  const [getCommonTags, { data: tagsData, isLoading: isLoadingTags }] =
    handleGetCommonTagQuery().useLazyQuery();

  const searchedTags = tagsData?.common_tags ?? [];

  const onChange = (value: string, shouldSave = false) => {
    getCommonTags({
      searchType: "name",
      searchWord: value,
    });
    handleChange(value, shouldSave);
  };

  return {
    searchedTags,
    handleChange,
    isLoadingTags,
    onChange,
  };
};
